import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/HomePage.css';
import { API_BASE_URL } from '../config';
import EpisodeCard from '../components/EpisodeCard';
import { Episode } from '../types/Episode';

const HomePage: React.FC = () => {
  const [episodes, setEpisodes] = useState<Episode[]>([]);
  const [visibleCount, setVisibleCount] = useState(5);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const fetchEpisodes = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/episodes`);
        const data = await response.json();
        const sorted = data.filter((ep: Episode) => ep.audioFile) // ✅ Only episodes with audio
                            .sort((a: Episode, b: Episode) =>
          new Date(b.datePublished).getTime() - new Date(a.datePublished).getTime()
        );
        setEpisodes(sorted);
      } catch (error) {
        console.error('Error fetching episodes:', error);
      }
    };

    fetchEpisodes();
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleScroll = () => {
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 100;
      if (nearBottom && visibleCount < episodes.length) {
        setVisibleCount(prev => prev + 5);
      }
    };

    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, [visibleCount, episodes.length]);

  const visibleEpisodes = episodes.slice(0, visibleCount);

  return (
    <div className="homepage-container">
      <div className="homepage-left">
        <h1>That's A Dumb Rule?</h1>
        <p>
          Welcome to the <i>That's a Dumb Rule?</i> podcast!</p>
          <p>
             Discover some of the strangest, obscure or downright silly rules in sports that have you asking “is that a dumb rule?” Listen in on the conversations between two sports enthusiasts wanting to answer this question. Some rules you already know, others are the industry’s best-kept secrets. Find out what they are, the history behind them, and judge for yourself if it’s a dumb rule or not!
        </p>
        <p>
          Listen to expert commentary, fan reactions, and real-world examples that make you rethink the game.
        </p>
        <Link to="/episodes" className="homepage-button">
          Browse All Episodes →
        </Link>
      </div>

      <div className="homepage-right" ref={scrollRef}>
        <h2>Recent Episodes</h2>
        <div className="episode-list">
          {visibleEpisodes.map((ep, idx) => (
            <EpisodeCard key={idx} episode={ep} />
          ))}
          {visibleCount >= episodes.length && (
            <p style={{ textAlign: 'center', marginTop: '2rem' }}>You've reached the end.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePage;